import { notification } from 'antd';
import CryptoJS from 'crypto-js';

export const dispatchError = (message, title) => {
  notification.open({
    message: title || 'Error',
    description: message || 'Error occurred while connecting to server.',
  });
};

export const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: message,
    description: description,
    placement: 'topRight',
  });
};

export const encryptPassword = (password) => {
  const key = CryptoJS.enc.Latin1.parse('MGTCAP@123456789');

  const iv = CryptoJS.enc.Latin1.parse('MGTCAP@123456789');
  return CryptoJS.AES.encrypt(
    password,
    key,
    { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
  ).toString();
};

export const decryptPassword = (password) => {
  const key = CryptoJS.enc.Latin1.parse('MGTCAP@123456789');
  const iv = CryptoJS.enc.Latin1.parse('MGTCAP@123456789');
  return CryptoJS.AES.decrypt(
    password,
    key,
    { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
  ).toString(CryptoJS.enc.Utf8);
};

export const getCurrentUser = () => {
  const user = localStorage.getItem("currentUser");
  return user ? JSON.parse(user) : null;
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const codes = {
  loginSuccess: 1000,
  userNotFound: 1021,
  invalidUserLogin: 1022,
  invalidPasswordLogin: 1023,
  lockAccountError: 1047,
  mfaEnabledForUser: 1048,
  inactiveUserLogin: 1024,
  passwordChangeUpdate: 1030,
  inquiryDataAdded: 3333,
  currentPasswordNoMatch: 1031,
}